import {
  CATERING_CAFE_ZUPAS_URL,
  ROUTE_FUNDRAISING,
  ROUTE_FAQ,
  REACT_APP_CLOUD_FRONT,
} from "../../../constants";
export const CARDS_DATA = [
  {
    image: `${REACT_APP_CLOUD_FRONT}/images/NewHomePage/friendsAndRewardsDesktop.png`,
    mobileImage: `${REACT_APP_CLOUD_FRONT}/images/NewHomePage/friendsAndRewardsMobile.png`,
    title: "REWARDS",
    description:
      "Friends don’t let friends eat without claiming points and racking up rewards.",
    color: "#E04300",
    link: ROUTE_FAQ,
  },
  {
    image: `${REACT_APP_CLOUD_FRONT}/images/NewHomePage/OfficeCatering.png`,
    mobileImage: `${REACT_APP_CLOUD_FRONT}/images/NewHomePage/OfficeCatering.png`,
    title: "CATERING",
    description: "Be the office MVP with catering that everyone will love.",
    color: "#198000",
    link: CATERING_CAFE_ZUPAS_URL,
  },
  {
    image: `${REACT_APP_CLOUD_FRONT}/images/NewHomePage/fundraisers.png`,
    mobileImage: `${REACT_APP_CLOUD_FRONT}/images/NewHomePage/fundraisers.png`,
    title: "FUNDRAISERS",
    description:
      "Getting support for your organization has never been easier (or tastier).",
    color: "#0956A8",
    link: ROUTE_FUNDRAISING,
  },
];
